export function save(key, value) {
  try {
    const serializedValue = JSON.stringify(value);
    localStorage.setItem(key, serializedValue);
  } catch (error) {
    console.error("Storage save failed:", error); // eslint-disable-line no-console
    // This usually happens if localStorage is full (5MB limit)
  }
}

export function get(key) {
  try {
    const item = localStorage.getItem(key);
    return item ? JSON.parse(item) : null;
  } catch (error) {
    console.error("Storage read failed:", error); // eslint-disable-line no-console
    return null;
  }
}

export function remove(key) {
  localStorage.removeItem(key);
}
